//----------------------------------------------------------------------------------------------------------------------
// Physics Utility
//----------------------------------------------------------------------------------------------------------------------

import HavokPhysics, { type HavokPhysicsWithBindings } from '@babylonjs/havok';
import { HavokPlugin } from '@babylonjs/core';

//----------------------------------------------------------------------------------------------------------------------

/**
 * Initializes the Havok WASM module and returns the raw bindings.
 *
 * Each BabylonJS scene needs its own HavokPlugin instance (because scene.dispose() disposes the
 * plugin attached to it). The raw WASM module can be shared across plugins safely.
 */
export async function initHavok() : Promise<HavokPhysicsWithBindings>
{
    return await HavokPhysics();
}

/**
 * Creates a new HavokPlugin from an existing WASM instance.
 */
export function createHavokPlugin(havok : HavokPhysicsWithBindings) : HavokPlugin
{
    return new HavokPlugin(true, havok);
}

//----------------------------------------------------------------------------------------------------------------------
